export default __webpack_public_path__ + "static/media/carousel-globalexchangemanager.21a72d03.jpg";